/**
 * @generated SignedSource<<80124cc992044e4f38fbe8e132630d2b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationFlourishCreateScreenMutation$variables = {
  authToken: string;
};
export type IntegrationFlourishCreateScreenMutation$data = {
  readonly store: {
    readonly activateIntegrationFlourish: boolean | null;
  };
};
export type IntegrationFlourishCreateScreenMutation = {
  response: IntegrationFlourishCreateScreenMutation$data;
  variables: IntegrationFlourishCreateScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "authToken"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "authToken",
            "variableName": "authToken"
          }
        ],
        "kind": "ScalarField",
        "name": "activateIntegrationFlourish",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationFlourishCreateScreenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationFlourishCreateScreenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d91071cff0a5f9ca3f852a892f212deb",
    "id": null,
    "metadata": {},
    "name": "IntegrationFlourishCreateScreenMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationFlourishCreateScreenMutation(\n  $authToken: String!\n) {\n  store {\n    activateIntegrationFlourish(authToken: $authToken)\n  }\n}\n"
  }
};
})();

(node as any).hash = "4df6a8cde02d59f8233b35395c3bcc48";

export default node;
